/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./oauthConsent.vue?vue&type=template&id=375c48f4&scoped=true"
import script from "./oauthConsent.vue?vue&type=script&lang=js"
export * from "./oauthConsent.vue?vue&type=script&lang=js"
import style0 from "./oauthConsent.vue?vue&type=style&index=0&id=375c48f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375c48f4",
  null
  
)

export default component.exports